import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {dataImport_template} from "../components/templates/dataImport_template";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;
declare var page: any;
declare var Dropzone: any;

export class data_import extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected data_import: dataImport_template;
    protected validationsList: validationsList_template;

    protected getModuleName(){
        return "data_import";
    }

    buildContent() : Array<Element>{

        this.validationsList = new validationsList_template("validationList", this.viewModel, this);

        this.data_import = new dataImport_template("importPageTemplate", this.viewModel, this);

        return [this.validationsList.build(), this.data_import.build()];
    }

    public fillPage() : void{

        this.data_import.buildDatePickerCalendar();

        let revenueReports = [
            { id: "", name: "- Choose Report -"},
            { id: "amazon affiliate report", name: "amazon affiliate report"},
            { id: "amazon onsite report", name: "Amazon OnSite Report"},
            { id: "netline report", name: "Netline Report"},
            { id: "sponsored direct report", name: "Sponsored Direct Report"},
            { id: "stackmedia report", name: "StackMedia Report"},
            { id: "disqus report", name: "Disqus Report"},
            { id: "marketplace_lotlinx", name: "Marketplace Lotlinx"},
            { id: "marketplace_carzing", name: "Marketplace CarZing"},
            { id: "marketplace_carsbids", name: "Marketplace Cars&Bids"},
        ];
        this.viewModel.importPageTemplate.reportFilter.setOptions(revenueReports);
        this.viewModel.importPageTemplate.reportFilter.setLabel("Report Type");


        this.generateDropzone();

        this.getAdvertiserData();
    }

    protected generateDropzone(){


        let myDropzone = new Dropzone("div#my-drop-zone", {
            url: "/api/data/upload/file/",
            maxFiles: 1,
            acceptedFiles: ".csv,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            dictDefaultMessage: "Drop files here or<br>Click to upload...",
        });

        let _this = this;

        myDropzone.on("success", function(file, serverFileName) {
            let responseParsed = serverFileName;
            _this.viewModel["importPageTemplate"].reportPath(responseParsed.data);
        });

    }

    protected getAdvertiserData(): void{

        // LOADING : starts
        //this.data_import.activateLoading();

        let usrReq_url: string = '/api/import/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON( "a" )] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.GET;

        this.XHRHdl.onReadyStateFunction = this.onGetReferences;
        this.XHRHdl.execute();
    }

    protected filterDateOnChange(){

    }

    protected filterDropdownOnChange(data) {
        if ('reportFilter' == data) {
            this.getAdvertiserData();
            let countries = this.data_import.getCountryList();

            this.data_import.setCountries(countries);
        }
    }

    protected filterSingleDateOnChange() {

    }

    protected onGetReferences(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.data_import.setBrands(responseParsed.data.brands);
                obj.data_import.setCountryList(responseParsed.data.countries);
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.data_import.deactivateLoading();
            }
        };
    }

    protected importReport(){

        let _this = this;
        let formReq_url: string = '/api/data/import/file/';
        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(_this.data_import.getViewModelForRequest())]);

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function (){

                //reset dropzone
                _this.viewModel["importPageTemplate"].reportPath(null);
                let objDZ = Dropzone.forElement("div#my-drop-zone");
                objDZ.removeAllFiles(true);
                objDZ.emit("resetFiles");

                obj.manageResponse(req, obj, function (){

                    obj.validationsList.clearMessages();
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Report imported successfully !");
                    obj.getVnAppZone().showNotificationToModule();
                    console.log("Report imported successfully");

                    _this.getAdvertiserData();
                });
            };
        });
        XHRHdl.execute();
    }
}



// WEBPACK FOOTER //
// ./js/modules/data_import.ts